import { Component } from '@angular/core';

@Component({
    selector: 'backend-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent {
  public emailAddress: string = 'ies-support.func@siemens-healthineers.com';
  public tooltipLabel: string = 'Copy';

  public copyEmailToClipboard(): void {
    navigator.clipboard.writeText(this.emailAddress).then(() => {
      this.tooltipLabel = 'Copied!';
      setTimeout(() => {
        this.tooltipLabel = 'Copy';
      }, 2000);
    });
  }
}
